<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                date: '',
                company_id: '',
                amount: '',
                partners: [],
                files: [],
                description: '',
            },
            share:{
                company_id:0,
                company:{
                    name:''
                }
            },
            sums:[0,0,0,0,0],
            files: [],
            type_id:0,
            approved: false,
            send: false,
            submitable:true,
        }
    },
    methods: {
        resetAmount(userId) {
            let partner=this.form.partners.find(p=> p.id==userId);
            if (!partner.checked) {
                partner.payment=0;
                partner.bank_account=0;
                partner.percentage=0;
                partner.subtotal=0;
                partner.advance=0;
                partner.retention=0;
                partner.amount=0;
            }else{
                let user=this.catalogue.company_user.find(u=>u.id==userId),
                bank_account=user.bank_accounts.find(a=> a.default),
                payment=2;
                if(partner.bank_accounts.length==0) payment=5;
                partner.payment=payment;
                partner.bank_account=bank_account? bank_account.id : 0,
                partner.percentage=Math.round((user.companies_partner[0].pivot.percentage??0)*1000000000000)/10000000000;
                this.updateTotal();
            }
        },
        closedModal() {
            this.form.id = '';
            this.form.company_id = '';
            const now = new Date();
            this.form.date = new Date(now.getFullYear(), now.getMonth() - 1, 1).toISOString().slice(0, 10);
            this.form.amount = '';
            this.form.partners = [];
            this.form.files = [];
            this.form.description = '';
            this.type_id=0;
            this.share={
                company_id:0,
                company:{
                    name:''
                }
            },
            this.sums=[0,0,0,0,0],
            this.files = [];
            this.approved = false;
            this.send = false;
            this.submitable = false;
            this.errors = {};
            this.catalogue.company_user=[];
            this.$modal.hide('addShare');
        },
        uploadFilesShare(event) {
            let vm = this;

            let file = event.target.files[0];
            vm.form.files.push(file);
            this.$forceUpdate();
        },
        createURL(file) {
            let link = URL.createObjectURL(file);
            return link;
        },
        async delImgUpload(pos) {
            let img = this.files[pos];
            let id = img.id;
            let _endpoint = '/partners/share/deleted-documents';
            let form = {
                id: id
            };
            let { data } = await request.postMedia(_endpoint, form)
            if (data) {
                this.successNotification(data.message);
                this.files.splice(pos, 1);
            }

        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se eliminó correctamente.');
        },
        async saveShare() {
            if(this.checkTotal()){
                this.send = true;
                const data_form = new FormData();
                data_form.append('id', this.form.id);
                data_form.append('company_id', this.form.company_id);
                data_form.append('date', this.form.date);
                data_form.append('amount', this.form.amount);
                data_form.append('description', this.form.description)

                this.form.files.forEach(function (valor, index) {
                    data_form.append('files[' + index + ']', valor);
                });

                const partnersArray = this.form.partners.map(partner => ({
                    id : partner.id,
                    payment: partner.payment || 0,
                    bank_account: partner.bank_account || 0,
                    percentage: partner.percentage || 0,
                    retention: partner.retention || 0,
                    advance: partner.advance || 0,
                    min: partner.min || 0,
                    amount: partner.amount || 0,
                    save: partner.checked || false,
                }));

                data_form.append('partners', JSON.stringify(partnersArray));

                let _endpoint = '/shares';
                if (this.form.id != "") {
                    data_form.append('_method', 'PUT');
                    _endpoint = `/shares/${this.form.id}`;
                }
                try {
                    let { data } = await request.postMedia(_endpoint, data_form)
                    if (data) {
                        this.successNotification(data.message);
                        this.closedModal();
                        Event.$emit('event-load-checks-shares');
                    }
                } catch (error) {
                    this.send = false;
                    this.errors = {};
                    if (error.response) {
                        this.errors = await this.errorNotification(error);
                        this.errorNotificationMessage(this.errors[Object.keys(this.errors)[0]][0]);
                    }
                }
            }else{
                this.$swal('La suma de los montos a repartir es mayor al monto total del reparto');
            }
        },
        checkTotal() {
            // let total=0;
            // this.form.partners.forEach(function(partner){
            //     total+=parseFloat(partner.subtotal);
            // })
            // return this.form.amount<=total;
            return true;
        },
        updateTotal(change=true) {
            if(this.prop_edit){
                let vm=this, sum1 = 0, sum2 = 0, sum3 = 0, sum4=0;
                this.errors=[];
                this.submitable=true;
                this.form.partners.forEach(function(partner){
                    if(partner.checked){
                        let subtotal=Math.round(parseFloat(parseFloat(partner.percentage)*parseFloat(vm.form.amount)))/100,
                            amount=subtotal,
                            retention=partner.retention,
                            advance=partner.advance,
                            total=0;
                            partner.subtotal=subtotal;
                        if(change){
                            if(partner.value>0){
                                retention=partner.type==1?parseFloat(subtotal)*partner.value:partner.value;
                            }else if(vm.type_id==1 && parseFloat(amount)>0){
                                let tax=vm.catalogue.share_taxes.find(a=> a.min<=amount && (a.max>=amount || (a.max??0) == 0) );
                                retention=parseFloat((amount-tax.min)*tax.percentage+tax.quota);
                            }else{
                                let rule=vm.catalogue.rules_shares.find(a=> a.id == vm.type_id);
                                retention=rule?(rule.type==1?parseFloat(subtotal)*rule.value:rule.value):0;
                            }
                        // }else{
                        //     retention=Math.min(retention,subtotal);
                        }
                        if(retention>subtotal){
                            vm.errors['retentions-'+partner.id]=['La Retención debe ser menor o igual al Remanente'];
                            vm.submitable=false;
                        }
                        partner.retention=retention;
                        total=parseFloat(parseFloat(partner.subtotal)-parseFloat(partner.retention)+parseFloat(partner.advance)).toFixed(2);
                        partner.amount=total;
                        sum1+=parseFloat(subtotal);
                        sum2+=parseFloat(retention);
                        sum4+=parseFloat(advance);
                        sum3+=parseFloat(total);
                        if(partner.payment==2&&partner.bank_accounts.length==0){
                            partner.payment=5;
                            vm.errorNotificationMessage('No se puede seleccionar el tipo de pago Transacción si no se cuenta con Cuentas Bancarias asociadas.');
                        }else if(partner.payment!=2&&partner.bank_accounts.length>0){
                            partner.bank_account=-1;
                        }
                        if(total<0) vm.submitable=false;
                    }
                })
                this.sums= [this.sums[0], sum1, sum2, sum3,sum4];
                if(this.sums[1]<=0) this.submitable=false;
            }
        },
		selectAll() {
        this.form.partners.forEach(element => {
				element.checked=true;
                this.resetAmount(element.id);
			});
		},
		deselectAll() {
			this.form.partners.forEach(element => {
				element.checked=false;
                this.resetAmount(element.id);
			});
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
			errorNotificationMessage: 'alert/errorMessage',
        }),
    },
    watch: {
        'form.company_id'(value) {
            if(value&&this.prop_edit)
                this.catalogue.get_company_user_partner(value);
            if(!this.approved){
                this.form.partners = [];
            }
        },
        'catalogue.company_user'() {
            let sum=0,vm=this;
            if(this.share.company_id==this.form.company_id){
                this.catalogue.company_user.forEach(partner => {
                    let user=vm.share.users.find(p=> p.id==partner.id),
                    company=partner.companies_partner.find(c=>c.id==vm.form.company_id),
                    min= -(parseFloat(user.advances_sum_amount)+parseFloat(user.share_users_sum_advance)),
                    amount=0,
                    payment=2,
                    percentage=0,
                    subtotal=0,
                    retention=0,
                    advance=0,
                    bank_account= 0,
                    editable=true,
                    checked= false;
                    if(user){
                        amount= user.pivot.amount,
                        payment= user.pivot.payment_id,
                        percentage= user.pivot.percentage*100,
                        subtotal= user.pivot.percentage*vm.share.amount,
                        retention= user.pivot.retention,
                        advance= user.pivot.advance,
                        bank_account= user.pivot.bank_account_id,
                        editable= advance<0,
                        checked= true;
                    }
                    if(partner.bank_accounts.length==0) payment=5;
                    vm.form.partners.push({
                        id: partner.id, 
                        name: partner.name + ' ' + partner. last_name,
                        amount: amount,
                        payment: payment,
                        percentage: percentage,
                        subtotal: subtotal,
                        retention: retention,
                        advance: advance,
                        bank_account: bank_account,
                        bank_accounts: partner.bank_accounts,
                        type: company.pivot.type,
                        value: company.pivot.retention??0,
                        min : min,
                        editable : editable,
                        checked : checked
                    });
                    sum+=percentage;
                });
            }else{
                this.catalogue.company_user.forEach(user => {
                    let percentage=Math.round((user.companies_partner[0].pivot.percentage??0)*1000000000000)/10000000000,
                    company=user.companies_partner.find(c=>c.id==vm.form.company_id),
                    bank_account= user.bank_accounts.find(a=> a.default),
                    advance= -(parseFloat(user.advances_sum_amount??0)+parseFloat(user.share_users_sum_advance??0)),
                    payment=2;
                    if(user.bank_accounts.length==0)
                        payment=5;
                    vm.form.partners.push({
                        id: user.id, 
                        name: user.name + ' ' + user. last_name,
                        amount: 0,
                        payment: payment,
                        percentage: percentage,
                        subtotal: 0,
                        retention: 0,
                        advance: advance,
                        bank_account: (bank_account? bank_account.id : 0),
                        bank_accounts: user.bank_accounts,
                        type: company.pivot.type,
                        value: company.pivot.retention??0,
                        min: advance,
                        editable : advance<0,
                        checked : true
                    });
                    sum+=percentage;
                });
                if(this.form.amount>0)
                    this.updateTotal();
            }
            this.sums[0]=Math.round(sum);
        },
        'form.amount'() {
            this.updateTotal();
        },
        'form.partners': {
            handler() {
                this.updateTotal(false);
            },
            deep: true
        },
        'type_id'() {
            this.updateTotal();
        },
        // 'form.partners'() {
        //     this.updateTotal(flase);
        // }
    },
    mounted() {
        if (this.authUser.organization_charts_id == 1 || this.authUser.organization_charts_id==4 || this.authUser.id==1123) {
            this.catalogue.get_companies_buildings();
        } else {
            this.catalogue.get_companies_users(this.authUser.id);
        }
        this.catalogue.get_type_payments_partners();
        this.catalogue.get_share_taxes();
        this.catalogue.get_rules_shares();
    },
    created() {
        Event.$on("event-show-addShare", async (share,prop_edit) => {
            this.catalogue.get_rules_shares();
            if (share.id) {
                this.share=share;
                this.form.company_id = share.company_id;
                if(prop_edit){
                    this.load = true;
                    this.approved=share.checks.length>0;
                    this.form.id = share.id;
                    this.form.date = share.date;
                    this.form.description = share.description;
                    this.type_id=-1;
                    // if(!this.approved)
                    // this.form.partners=[];
                    // await this.catalogue.get_company_user_partner(share.company_id);
                    // else    
                    //     this.catalogue.company_user=share.users;

                    if (share.files) {
                        this.files = share.files;
                    }

                    this.form.amount = share.amount;

                    this.updateTotal();
                }else{
                    let sum0=0, sum1 = 0, sum2 = 0, sum3 = 0, sum4 = 0;

                    share.users.forEach(user=>{
                        sum0+=Math.round(user.pivot.percentage * 1000000000000)/10000000000;
                        sum1+=user.pivot.amount + user.pivot.retention-user.pivot.advance;
                        sum2+=user.pivot.retention;
                        sum3+=user.pivot.amount;
                        sum4+=user.pivot.advance;
                    })
                    this.sums= [sum0, sum1, sum2, sum3, sum4];
                }
            }else{
                const now = new Date();
                this.form.date = new Date(now.getFullYear(), now.getMonth() - 1, 1).toISOString().slice(0, 10);
            }
            this.$modal.show('addShare');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addShare" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveShare" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" v-if="prop_edit">Agregar Reparto</h5>
                <h5 class="modal-title" id="exampleModalLabel" v-else>Detalle de Reparto</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6 mt-3" v-if="prop_edit && !approved">
                        <label>Empresa</label>
						<select v-model="form.company_id" class="form-control" :disabled="!prop_edit" v-if="authUser.organization_charts_id == 1 || authUser.organization_charts_id==4 || authUser.id==1123">
							<option value=""> Sin empresa </option>
							<option v-for="(company, index) in catalogue.companies_buildings" :value="company.id" :key="index">
								{{ company.name }}</option>
						</select>

						<select v-model="form.company_id" class="form-control"  :disabled="!prop_edit" v-else>
                            <option value=""> Sin empresa </option>
                            <option v-for="(company, index) in catalogue.companies_users" :value="company.id" :key="index">
                                {{ company.name }}
							</option>
                        </select>
                        <div v-if="errors && errors.company_id" class="text-danger">
                            {{ errors.company_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Empresa</label>
                        {{ share.company.name }}
                        <input type="hidden" v-model="form.company_id">
                    </div>

                    <div class="col-md-6 mt-3" v-if="prop_edit && !approved">
                        <label>Fecha</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" required="required"
                             valueType="format" type="month"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Fecha</label>
                        {{ share.date | toDateTime }}
                        <input type="hidden" v-model="form.date">
                    </div>

                    <div class="col-md-6 mt-3" v-if="prop_edit && !approved">
                        <label>Total a repartir</label>
                        <money :disabled="!prop_edit || !form.partners.length > 0"
                            class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Total a repartir</label>
                        {{ share.amount | toCurrency }}
                        <input type="hidden" v-model="form.amount">
                    </div>

                    <div class="col-md-6 mt-3" v-if="prop_edit && !approved">
                        <label>Tipo de Reparto</label>
						<select v-model="type_id" class="form-control">
							<option v-for="(rule, index) in catalogue.rules_shares" :value="rule.id" :key="index">
								{{ rule.name }} ({{ rule.description }})</option>
						</select>
                    </div>

                    <div class="col-12 mt-3">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th v-if="prop_edit">
                                        <button v-if="prop_edit && this.form.partners.filter(p=>p.checked==true).length<this.catalogue.company_user.length" class="btn btn-sm btn-info" @click.prevent="selectAll">
                                            <i class="fa-solid fa-check-square"></i>
                                        </button>
                                        <button v-else-if="prop_edit" class="btn btn-sm btn-info" @click.prevent="deselectAll">
                                            <i class="fa-solid fa-square"></i>
                                        </button>
                                    </th>
                                    <th>Socio</th>
                                    <th>Forma de pago</th>
                                    <th>Cuenta</th>
                                    <th>%</th>
                                    <th>Remanente</th>
                                    <th>Retención</th>
                                    <th>Pago de Adelanto</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody v-if="prop_edit">
                                <tr v-for="(user, index_user) in form.partners" :key="index_user">
                                    <td>
                                        <input :disabled="!prop_edit || (share.checks && share.checks.find(c=> c.user_id == user.id))" type="checkbox" v-model="user.checked"
                                            :value="user.id" @change="resetAmount(user.id)" class="form-control"
                                            :id="'id-' + user.id">
                                    </td>
                                    <td>
                                        <div v-if="authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == form.company_id })">
                                        <!-- <div v-if="authUser.companies.includes(form.company_id)"> -->
                                            {{ user.name }}
                                        </div>
                                        <div v-else>
                                            XXXXXXX XXXXXXXX
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="share.checks && share.checks.find(c=> c.user_id == user.id)">
                                            {{ catalogue.type_payments.find(p => p.id==user.payment).name }}
                                        </div>
                                        <select type="text" :disabled="!prop_edit || !user.checked"
                                            class="form-control" v-model="user.payment"
                                            :id="'type_payment-' + user.id"
                                            v-else>
                                            <option v-for="(payment, index_payment) in catalogue.type_payments"
                                                :value="payment.id" :key="index_payment">
                                                {{ payment.name }}
                                            </option>
                                        </select>
                                        <div v-if="errors && errors['partners-'+user.id+'-payment']" class="text-danger">{{
                                            errors['partners-'+user.id+'-payment'][0] }}</div>
                                    </td>
                                    <td v-if="user.bank_accounts && user.bank_accounts.length > 0">
                                        <div v-if="share.checks && share.checks.find(c=> c.user_id == user.id)">
                                            <span v-if="bank=user.bank_accounts.find(b => b.id==user.bank_account)">{{ bank.name }} - {{ bank.bank_accounts.find(b => b.id==user.bank_account).account_number }}</span>
                                            <span v-else>Sin cuenta bancaria</span>
                                        </div>
                                        <select type="text" :disabled="!prop_edit || !user.checked"
                                            class="form-control" v-model="user.bank_account"
                                            :id="'bank_accounts-' + user.id"
                                            v-else>
                                            <option v-for="(bank, index_bank) in user.bank_accounts" :value="bank.id"
                                                :key="index_bank">
                                                <span>{{ bank.bank.name }}</span> - {{ bank.account_number }}
                                            </option>
                                        </select>
                                        <div v-if="errors && errors['partners-'+user.id+'-bank_account']" class="text-danger">{{
                                            errors['partners-'+user.id+'-bank_account'][0] }}</div>
                                    </td>
                                    <td v-else>Sin cuenta bancaria</td>
                                    <td>
                                        <input type="number" class="form-control" v-model="user.percentage"
                                            :id="'percentages-' + user.id" readonly>
                                    </td>
                                    <td>
                                        <money class="form-control" v-model="user.subtotal"
                                        :id="'subtotals-' + user.id" readonly></money>
                                    </td>
                                    <td>
                                        <money class="form-control" v-model="user.retention"
                                            :id="'retentions-' + user.id"
                                            :readonly="share.checks && share.checks.find(c=> c.user_id == user.id)"></money>
                                    </td>
                                    <td>
                                        <money class="form-control" v-model="user.advance"
                                        :id="'advances-' + user.id" :readonly="!user.editable" :min="user.min" max="0"></money>
                                        <div v-if="errors && errors['partners-'+user.id+'-advance']" class="text-danger">{{
                                            errors['partners-'+user.id+'-advance'][0] }}</div>
                                    </td>
                                    <td>
                                        <money class="form-control" v-model="user.amount"
                                        :id="'amounts-' + user.id" readonly></money>
                                        <div v-if="errors && errors['partners-'+user.id+'-amount']" class="text-danger">{{
                                            errors['partners-'+user.id+'-amount'][0] }}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(user, index_user) in share.users" :key="index_user">
                                    <td>
                                        <div v-if="authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == form.company_id })">
                                        <!-- <div v-if="authUser.companies.includes(form.company_id)"> -->
                                            {{ user.name }} {{ user.last_name }}
                                        </div>
                                        <div v-else>
                                            XXXXXXX XXXXXXXX
                                        </div>
                                    </td>
                                    <td>
                                        {{ user.pivot.type_payment.name }}
                                    </td>
                                    <td v-if="(authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == form.company_id })) && user.pivot.bank_account_provider">
                                        {{ user.pivot.bank_account_provider.bank.name }} - {{ user.pivot.bank_account_provider.account_number }}
                                    </td>
                                    <td v-else-if="authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == form.company_id })">
                                        Sin cuenta bancaria
                                    </td>
                                    <td v-else>
                                        XXXXXXX XXXXXXXX
                                    </td>
                                    <td>
                                        {{ Math.round(user.pivot.percentage * 100000)/1000 }}%
                                    </td>
                                    <td>
                                        {{ user.pivot.amount + user.pivot.retention - user.pivot.advance | toCurrency }}
                                    </td>
                                    <td>
                                        {{ user.pivot.retention | toCurrency }}
                                    </td>
                                    <td>
                                        {{ user.pivot.advance | toCurrency }}
                                    </td>
                                    <td>
                                        {{ user.pivot.amount | toCurrency }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="form.partners.length > 0">
                                <tr class="table-secondary">
                                    <td colspan="4">
                                        Total :
                                    </td>
                                    <td class="text-right">
                                        {{ Math.round(sums[0])}}%
                                    </td>
                                    <td class="text-right">
                                        {{ sums[1] | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ sums[2] | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ sums[4] | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ sums[3] | toCurrency }}
                                    </td>
                                </tr>
                            </tfoot>
                            <tfoot v-else-if="(share.users && share.users.length>0)">
                                <tr class="table-secondary">
                                    <td colspan="3">
                                        Total :
                                    </td>
                                    <td class="text-right">
                                        {{ Math.round(sums[0])}}%
                                    </td>
                                    <td class="text-right">
                                        {{ sums[1] | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ sums[2] | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ sums[4] | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ sums[3] | toCurrency }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                        <div v-if="errors && errors.partners" class="text-danger">{{ errors.partners[0] }}</div>
                    </div>

                    <div class="col-12">
                        <div class="row justify-content-end">
                            <div class="col-md-12 mt-2" v-if="prop_edit">
                                <label>Concepto</label>
                                <textarea type="text" :disabled="!prop_edit" class="form-control"
                                    v-model="form.description"></textarea>
                                <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                            </div>
                            <div class="col-md-12 mt-2" v-else>
                                <label>Concepto</label>
                                {{ share.description }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>
                        <div class="row">
                            <div class="col-12 text-center">
                                <h3>Archivo adjuntos.</h3>
                                <p>Máximo 15 archivos.</p>
                                <div class="row mt-4 mb-4">
                                    <div class="col-12" v-if="(form.files.length + files.length) == 0">
                                        <i class="fa-solid fa-file fa-4x"></i>
                                        <p>Sin archivos adjuntos</p>
                                    </div>
                                    <div class="col-md-4 col-12 p-2" v-for="(fAdd, index_fAdd) in files"
                                        :key="index_fAdd" v-show="files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImgUpload(index_fAdd)">
                                                <i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="`${globalUrlFiles}${fAdd.file}`" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ fAdd.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
                                        :key="index_img" v-show="form.files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImg(index_img)"><i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="createURL(img)" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ img.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="input-group mb-3"
                                    v-if="(form.files.length + files.length) <= 14 && prop_edit">
                                    <div class="custom-file" @change="uploadFilesShare">
                                        <input type="file" class="custom-file-input" id="inputGroupFile03"
                                            aria-describedby="inputGroupFileAddon03">
                                        <label class="custom-file-label" for="inputGroupFile03">
                                            Subir Archivo
                                        </label>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send||!submitable" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>